module.exports = __webpack_public_path__ + "img/MF.d5dce716.svg";